import type { BorrowMarketRow } from '@/hooks/useBorrowMarkets'
import type { BorrowMarketsSortState } from '@/types/borrowMarketsSortState'

type SortableValue = number | string | undefined

function compareValues(a: SortableValue, b: SortableValue, asc: boolean) {
  if (a === undefined && b === undefined) return 0
  if (a === undefined) return 1
  if (b === undefined) return -1

  const result = typeof a === 'number' && typeof b === 'number' ? a - b : String(a).localeCompare(String(b))

  return asc ? result : -result
}

export function sortBorrowMarkets(borrowMarkets: BorrowMarketRow[], { sortBy, asc }: BorrowMarketsSortState) {
  return [...borrowMarkets].sort((a, b) => {
    switch (sortBy) {
      case 'token':
        return compareValues(a.tokenSymbol.toLowerCase(), b.tokenSymbol.toLowerCase(), asc)
      case 'protocol':
        return compareValues(a.protocolName.toLowerCase(), b.protocolName.toLowerCase(), asc)
      case 'name':
        return compareValues(a.name.toLowerCase(), b.name.toLowerCase(), asc)
      case 'availableToBorrow':
        return compareValues(a.availableToBorrowUsd, b.availableToBorrowUsd, asc)
      case 'borrowRate':
        return compareValues(a.borrowRate, b.borrowRate, asc)
      case 'marketSize':
      default:
        return compareValues(a.marketSizeUsd, b.marketSizeUsd, asc)
    }
  })
}
